<template>
    <action-menu
        icon="CurlyBraces"
        :items="placeholderItems"
        :absolute="false"
        :open-menu-below="true"
        :open-menu-right="openMenuRight"
        @action="emitPlaceholder($event)"
        @subAction="emitPlaceholder($event)"
    >
        <template v-slot:activator="{ on: menuOn }">
            <slot name="activator" :on="menuOn"/>
        </template>
    </action-menu>
</template>

<script>
import {computed, ref, watch} from "@vue/composition-api";
import ApiEmailAutomationPlaceholders from "../../api/email_automation/placeholders"

export default {
    name: "RichTextEditorPlaceholders",
    props: {
        richTextEditor: {
            type: Object,
            default: null
        },
        placeholderTypes: {
            type: Array,
            default: () => []
        },
        companyId: {
            type: Number,
            default: null
        },
        openMenuRight: {
            type: Boolean,
            default: true
        },
    },
    setup(props, ctx) {
        let additionalPlaceholderItems = ref([])

        const placeholderItems = computed(() => {
            return additionalPlaceholderItems.value
        })

        watch(() => props.placeholderTypes, async (newVal, oldVal) => {
            const isFirstInitialization = newVal && !oldVal

            const samePlaceholderTypes = newVal && oldVal && newVal.length === oldVal.length && newVal.every(val => oldVal.includes(val))
            if (props.companyId && (isFirstInitialization || !samePlaceholderTypes)) {
                const data = await ApiEmailAutomationPlaceholders.getPlaceholders(props.companyId, props.placeholderTypes)
                additionalPlaceholderItems.value = data.placeholders
            }
            ctx.emit('placeholders', placeholderItems.value)
        })

        const emitPlaceholder = (placeholderLocation) => {
            let index
            let subIndex = null

            if (typeof placeholderLocation === 'object') {
                index = placeholderLocation.index
                subIndex = placeholderLocation.subIndex
            } else {
                index = placeholderLocation
            }

            if (index === null) {
                return ""
            }

            let placeholder = placeholderItems.value[index]
            if (subIndex !== null) {
                placeholder = placeholderItems.value[index].value[subIndex]
            }
            ctx.emit('placeholder', placeholder)
        }


        return {
            placeholderItems,
            additionalPlaceholderItems,
            emitPlaceholder,
        }
    }
}
</script>

<style scoped>

</style>